import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=67ab6b98&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"
import style0 from "./Start.vue?vue&type=style&index=0&id=67ab6b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab6b98",
  null
  
)

/* custom blocks */
import block0 from "./Start.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/global.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Fabdl-party%2Fweb%2Fwebapp%2Fsrc%2Fviews%2FStart.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports